import React from 'react';
import ReactApexChart from 'react-apexcharts';

import { useTheme } from 'styled-components';

import { Container, Label } from './styles';

interface IDistributedColumnsPrices3Props {
  label?: string;
  category?: string;
  price: number;
}

const DistributedColumnsPrices3: React.FC<IDistributedColumnsPrices3Props> = ({
  label,
  category,
  price,
}: IDistributedColumnsPrices3Props) => {
  const { colors } = useTheme();

  const optionColors = [colors.chartPrice];

  const series = [
    {
      name: '',
      data: [price],
    },
  ];

  const options = {
    chart: {
      offsetX: 0,
      offsetY: 0,
      redrawOnWindowResize: true,
      toolbar: {
        show: false,
      },
    },
    colors: optionColors,
    plotOptions: {
      bar: {
        columnWidth: '50%',
        distributed: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: [category !== undefined ? category : 'Valor'],
      labels: {
        style: {
          colors: optionColors,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        show: true,
        formatter: (value: number) => {
          return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
    },
  };

  return (
    <Container>
      {label && <Label>{label}</Label>}

      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </Container>
  );
};

export default DistributedColumnsPrices3;
